import React from 'react';
import * as Icon from 'ubs-icons';
import InApp from 'detect-inapp';
import PropTypes from "prop-types";
import UTags from "../UTags";

const UMenuOptions = props => {
    const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera);
    const redirectModule = (e) => {
        window.open(e, "_blank");
    }
    return (
        <React.Fragment>
            <div className="u_menu-options">

                {!props?.isMobile && <div className="u_menu-options-modules">
                    <ul>
                        {props?.HRMSURL && <li className={`${props?.active === 'hrms' ? 'u_active' : ''}`}
                                               onClick={() => redirectModule(props?.HRMSURL)}>
                            <span> <Icon.HRMS size={18}/> </span>
                            <h4>Super HRMS</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}
                        {props?.PMSURL && <li className={`${props?.active === 'pms' ? 'u_active' : ''}`}
                                              onClick={() => redirectModule(props?.PMSURL)}>
                            <span><Icon.PMS size={18}/></span>
                            <h4>Super Project</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}
                        {props?.chatURL && <li className={`${props?.active === 'chat' ? 'u_active' : ''}`}
                                               onClick={() => redirectModule(props?.chatURL)}>
                            <span><Icon.UbsChat size={18}/></span>
                            <h4>Super Chat</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}
                        {props?.PayrollURL && <li className={`${props?.active === 'payroll' ? 'u_active' : ''}`}
                                                  onClick={() => redirectModule(props?.PayrollURL)}>
                            <span><Icon.PayrollLogo size={18}/></span>
                            <h4>Super Payroll</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}

                        {props?.SurveyURL && <li className={`${props?.active === 'survey' ? 'u_active' : ''}`}
                                                  onClick={() => redirectModule(props?.SurveyURL)}>
                            <span><Icon.SurveyLogo size={18}/></span>
                            <h4 className="u_flex u_align-center ">Super Survey</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}

                        {props?.ATSURL && <li className={`${props?.active === 'ats' ? 'u_active' : ''}`}
                                              onClick={() => redirectModule(props?.ATSURL)}>
                            <span><Icon.ATSLogo size={18}/></span>
                            <h4 className="u_flex u_align-center ">Super ATS</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}
                        {props?.AssetsURL && <li className={`${props?.active === 'assets' ? 'u_active' : ''}`}
                                              onClick={() => redirectModule(props?.AssetsURL)}>
                            <span><Icon.AssetsLogo size={18}/></span>
                            <h4 className="u_flex u_align-center ">Super Assets</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}
                        {props?.PerformanceURL && <li className={`${props?.active === 'performance' ? 'u_active' : ''}`}
                                                      onClick={() => redirectModule(props?.PerformanceURL)}>
                            <span><Icon.Performance size={18}/></span>
                            <h4 className="u_flex u_align-center ">Super Performance</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}
                        {props?.TrackURL && <li className={`${props?.active === 'track' ? 'u_active' : ''}`}
                                                      onClick={() => redirectModule(props?.TrackURL)}>
                            <span><Icon.SuperTrack size={18}/></span>
                            <h4 className="u_flex u_align-center ">Super Track</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}
                        {props?.VMSURL && <li className={`${props?.active === 'vms' ? 'u_active' : ''}`}
                                                      onClick={() => redirectModule(props?.VMSURL)}>
                            <span><Icon.VMS size={18}/></span>
                            <h4 className="u_flex u_align-center ">Super VMS</h4>
                            <Icon.ArrowLeftLine fill="#007AFF" size={14} className="u_arrow"/>
                        </li>}
                    </ul>
                </div>}

                {
                    (props?.options.includes('release') || props?.options.includes('download') || props?.options.includes('mode') || props?.options.includes('troubleshooting') || props?.options.includes('appVersion') || props?.options.includes('videoUrl') || props?.options.includes('g2Review')) &&
                    <div className={`u_menu-options-list ${props?.isMobile ? 'u_mobile' : ''} `}>
                        <ul>
                            {props?.options?.includes('release') &&
                            <li onClick={() => props?.onMenuClick('release')}>
                                <p>
                                    <Icon.ReleaseNote fill="#4E525F" size={18}/>
                                    New Release
                                </p>
                                {props?.version?.length &&
                                <span className="u_light-badge u_light-badge-green">{props?.version}</span>}
                            </li>
                            }
                            {props?.options?.includes('download') &&
                            <li onClick={() => props?.onMenuClick('download')}>
                                <p>
                                    <Icon.DownloadCloud fill="#4E525F" size={18}/>
                                    Download App
                                </p>
                            </li>
                            }
                            {props?.subscriptionURL &&
                            <li onClick={() => redirectModule(props?.subscriptionURL)}>
                                <p>
                                    <Icon.Sparkle fill="#4E525F" size={20}/>
                                    Upgrade Plan
                                </p>
                            </li>
                            }
                            {(props?.options.includes('videoUrl') && props?.projectTitle)?
                                <li onClick={() => redirectModule(props?.videoUrl)}>
                                    <p>
                                        <Icon.Video fill="#4E525F" size={18}/>
                                        {`${props?.projectTitle}`}
                                    </p>
                                </li> : ''
                            }
                            {
                                props?.options?.includes('mode') &&
                                <li onClick={() => props?.onMenuClick('mode')}>
                                    <p>
                                        <Icon.DarkModeFill fill="#4E525F" size={18}/>
                                        Light/Dark
                                    </p>
                                </li>
                            }
                            {props?.options?.includes('troubleshooting') &&
                            <li onClick={() => props?.onMenuClick('troubleshooting')}>
                                <p>
                                    <Icon.Setting fill="#4E525F" size={18}/>
                                    Troubleshooting
                                </p>
                            </li>
                            }

                            {props?.isMobile && props?.options?.includes('appVersion') ?
                                <li>
                                    <p>App Version: {props?.appVersion}</p>
                                </li> : ''
                            }
                            {
                                props?.options?.includes('g2Review') &&
                                <li onClick={() => props?.onMenuClick('g2Review')}>
                                    <p>
                                        <Icon.G2 fill="#4E525F" size={18}/>
                                        <span ref={(el) => {
                                            if (el && window.g2 && !el.hasChildNodes()) {
                                                window.g2('write-a-review', {
                                                    productSlug: 'superworks',
                                                    host: "https://www.g2.com",
                                                    element: el,
                                                    buttonText: "Write a G2 Review",
                                                    buttonColor: "#fff",
                                                    // buttonHoverColor: "transparent",
                                                    // buttonTextColor: "#4E525F"
                                                });
                                            }
                                        }}></span>
                                    </p>
                                </li>
                            }
                        </ul>
                    </div>
                }

                {
                    (props?.options.includes('documents') || props?.options.includes('shortcuts') || props?.options.includes('support')) &&
                    <div className="u_menu-options-list">
                        <ul>
                            {
                                props?.options?.includes('documents') &&
                                <li onClick={() => props?.onMenuClick('documents')}>
                                    <p>
                                        <Icon.FilePreview fill="#4E525F" size={18}/>
                                        Documents
                                    </p>
                                </li>
                            }
                            {
                                props?.options?.includes('shortcuts') &&
                                <li onClick={() => props?.onMenuClick('shortcuts')}>
                                    <p>
                                        <Icon.Forward fill="#4E525F" size={18}/>
                                        Shortcuts
                                    </p>
                                </li>
                            }
                            {
                                props?.options?.includes('support') &&
                                <li onClick={() => props?.onMenuClick('support')}>
                                    <p>
                                        <Icon.QuestionMark fill="#4E525F" size={18}/>
                                        Support
                                    </p>
                                </li>
                            }
                        </ul>
                    </div>
                }
            </div>
        </React.Fragment>
    );
};
UMenuOptions.propTypes = {
    active: PropTypes.string,
    options: PropTypes.array,
    onMenuClick: PropTypes.func,
    version: PropTypes.string,
}

UMenuOptions.defaultProps = {
    active: 'hrms',
    optionsOne: [], // ['download', 'release', 'mode', 'documents', 'shortcuts', 'support']
    onMenuClick: () => {
    },
};

export default UMenuOptions;

